export enum TaskTemplateAssigneeRole {
    PREPARER = "preparer",
    REVIEWER = "reviewer",
    CLIENT = "client",
    MANAGER = "manager",
}

/**
 * Roles that make up a client's engagement team (excludes CLIENT).
 * Single source of truth for engagement-team role filtering across the
 * frontend filter UI, the shared zod schemas, and the backend close-overview query.
 *
 * Kept in a dependency-free leaf module so the shared filter schemas can
 * reference it without pulling in the heavier task type graph (which would
 * otherwise create an import cycle through `views`/`general` filters).
 */
export const ENGAGEMENT_TEAM_ROLES = [
    TaskTemplateAssigneeRole.PREPARER,
    TaskTemplateAssigneeRole.REVIEWER,
    TaskTemplateAssigneeRole.MANAGER,
] as const;

export type EngagementTeamRole = (typeof ENGAGEMENT_TEAM_ROLES)[number];
